import { State } from "../js/enums";

import {
  ApiMocker,
  embed,
  waitForYlePlayerAvailable
} from "./playerStateTestPage-helpers";

const audioSomethingWentWrong = "1-50006944";
const audio1 = "1-71023796";

let apiMocker: ApiMocker;

const clearLocationLoginMocks = () => {
  apiMocker.clearMock(__LOGIN_API);
  apiMocker.clearMock(__LOCATION_API);
};

const embedBlockedAudio = async () => {
  apiMocker.mockLocationApi("US", false);
  apiMocker.mockLoginApi(false);
  await embed({
    audioPlayer: true,
    embedId: audio1,
    state: State.BLOCKED,
    text: "Audio available only in Finland and user is not in Finland."
  });
  clearLocationLoginMocks();
};

const embedGoneAudio = async () => {
  apiMocker.mockPlayerApi(audio1, State.GONE, {});
  await embed({
    audioPlayer: true,
    embedId: audio1,
    state: State.GONE,
    text: "Program is no longer available."
  });
};

const embedPendingAOD = async () => {
  const pendingStartTime = new Date();
  pendingStartTime.setHours(pendingStartTime.getHours() + 2);
  apiMocker.mockPlayerApi(audio1, State.PENDING_ONDEMAND, {
    start_time: pendingStartTime.toISOString()
  });
  await embed({
    audioPlayer: true,
    embedId: audio1,
    state: State.PENDING_ONDEMAND,
    text: "Ondemand audio is not yet available."
  });
};

const embedNotFoundAudio = async () => {
  await embed({
    audioPlayer: true,
    embedId: "1-99999999",
    state: "Not found",
    text: "The media does not exist (player api returns 404 error)."
  });
};

const embedErrorState = async () => {
  apiMocker.mockPlayerApi(audio1, State.ERROR, {});
  await embed({
    embedId: audio1,
    state: State.ERROR,
    text: "Player got an error and media cannot be played."
  });
};

const embedNotAllowed = async () => {
  apiMocker.mockPlayerApi(audio1, State.NOT_ALLOWED, {});
  await embed({
    embedId: audio1,
    state: State.NOT_ALLOWED,
    text: "The player has been embedded outside of yle.fi domain and the selected media is not allowed to play outside yle.fi."
  });
};

const errorPlaybackAOD = async () => {
  apiMocker.mockCdn(
    "https://cdnapi.kaltura.com/p/1956791/sp/0/playManifest/entryId/1_ymcqfmml/format/url/flavorParamId/1958141"
  );
  await embed({
    embedId: audioSomethingWentWrong,
    state: State.ONGOING_ONDEMAND + " (error)",
    text: "Something went wrong and player cannot continue or start playback."
  });
};

const errorPlaybackLive = async () => {
  apiMocker.mockCdn("https://yleradiolive.akamaized.net/");
  await embed({
    embedId: "ylex",
    state: State.ONGOING_CHANNEL + " (error during playback)",
    text: "The playback fails for some reason during playback. Play audio to see the error."
  });
};

const renderPlayers = async () => {
  await waitForYlePlayerAvailable();

  apiMocker = new ApiMocker();
  await apiMocker.initialize();

  await embedBlockedAudio();
  await embedGoneAudio();
  await embedPendingAOD();
  await embedNotAllowed();
  await errorPlaybackAOD();
  await errorPlaybackLive();
  await embedErrorState();
  await embedNotFoundAudio();
};

window.addEventListener("DOMContentLoaded", () => {
  const errorElem = document.getElementById(
    "service-worker-error"
  ) as HTMLOutputElement;
  if ("serviceWorker" in navigator) {
    renderPlayers();
  } else if (["local.yle.fi", "localhost"].includes(window.location.hostname)) {
    errorElem.value = "Page does not work on local.yle.fi or localhost.";
  } else {
    errorElem.value = "Failed to register service worker.";
  }
});
